module.exports = __webpack_public_path__ + "img/wenku8.d85293cd.png";